(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["featured-blog-posts"] && !Shopify.designMode) return;
  try {
    
document.addEventListener('DOMContentLoaded', () => {
  const carousel = document.querySelector('#blogCarousel');
  const nextBtn = document.querySelector('.blog-arrow.next');
  const prevBtn = document.querySelector('.blog-arrow.prev');

  if (!carousel || !nextBtn || !prevBtn) return;

  const scrollAmount = carousel.clientWidth * 0.9;

  nextBtn.addEventListener('click', () => {
    carousel.scrollBy({ left: scrollAmount, behavior: 'smooth' });
  });

  prevBtn.addEventListener('click', () => {
    carousel.scrollBy({ left: -scrollAmount, behavior: 'smooth' });
  });

  function updateArrows() {
    prevBtn.style.opacity = carousel.scrollLeft <= 0 ? 0.4 : 1;

    const end = carousel.scrollWidth - carousel.clientWidth - carousel.scrollLeft;
    nextBtn.style.opacity = end <= 2 ? 0.4 : 1;
  }

  carousel.addEventListener('scroll', updateArrows);
  updateArrows();
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-list"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', () => {
    const carousel = document.querySelector('#productCarousel');
    const nextBtn = document.querySelector('.carousel-arrow.next');
    const prevBtn = document.querySelector('.carousel-arrow.prev');
    if (!carousel || !nextBtn || !prevBtn) return;

    const scrollAmount = carousel.clientWidth * 0.9;

    nextBtn.addEventListener('click', () => {
      carousel.scrollBy({ left: scrollAmount, behavior: 'smooth' });
    });

    prevBtn.addEventListener('click', () => {
      carousel.scrollBy({ left: -scrollAmount, behavior: 'smooth' });
    });

    function updateArrows() {
      prevBtn.style.opacity = carousel.scrollLeft <= 0 ? 0.4 : 1;
      const end = carousel.scrollWidth - carousel.clientWidth - carousel.scrollLeft;
      nextBtn.style.opacity = end <= 2 ? 0.4 : 1;
    }

    carousel.addEventListener('scroll', updateArrows);
    updateArrows();
  });

  } catch(e) { console.error(e); }
})();
})();
